import { render, staticRenderFns } from "./IndexAddBar.vue?vue&type=template&id=6c3e8ad6&scoped=true&"
import script from "./IndexAddBar.vue?vue&type=script&lang=js&"
export * from "./IndexAddBar.vue?vue&type=script&lang=js&"
import style0 from "./IndexAddBar.vue?vue&type=style&index=0&id=6c3e8ad6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3e8ad6",
  null
  
)

export default component.exports